<template>
	<vs-prompt
		@accept="updateManagerResponsibleWeek"
		:active.sync="popupActive"
		:title="$t('selectMultiManagersTitle')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		class="add-order-task"
	>
		<div>
			<vx-input-group class="mb-4">
                <div class="mb-4 text-center">
					<strong>{{ $t('selectResponsible') }}</strong>
				</div>
				<div class="form-group form-check">
					<v-select
						:clearable="false"
						class="single-row-select frsSelect"
						label="full_name"
						:options="listManagers"
						item-value="id"
						:items="listManagers"
						v-model="selectedResponsibleManager"
						@input="onChangeResponsibleManager"
					>      
						<template slot="selected-option" slot-scope="option">
							<span class="frsSelectSpanManager">
								<img :src="option.photo" />
								{{ option.full_name }}&nbsp; 
								<span>
									<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
									<strong>{{ option.count_active_order }}</strong>
								</span>
							</span>
						</template>
						<template #option="option">
							<span class="frsSelectSpanManager">
								<img :src="option.photo" />
								{{ option.full_name }}&nbsp; 
								<span>
									<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
									<strong>{{ option.count_active_order }}</strong>
								</span>
							</span>
						</template>
					</v-select>
				</div>
			</vx-input-group>

			<vx-input-group class="mb-4">
				<div class="mb-4 mt-2 text-center">
					<strong>{{ $t('areaResponsibility') }}</strong>
				</div>

                <div class="form-group form-check">
                    <div class="flex mb-4"
                        v-for="manager in listCheckManagers"
                    >
                        <input class="mr-2 text-lg" type="checkbox" 
							:id="manager.id"
							:value="manager"
							v-model="selectedManagers"
						> 
                        <label class="text-lg" :for="manager.id">
							<span class="frsSelectSpanManager text-lg">
								<img :src="manager.photo" />
								{{ manager.full_name }}&nbsp; 
								<span class="text-sm">
									<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
									<strong>{{ manager.count_active_order }}</strong>
								</span>
							</span>
						</label>
                    </div>
                </div>
			</vx-input-group>
		</div>
	</vs-prompt>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import vSelect from "vue-select";

export default {
	name: "ChangeResponsibleManagerForDutySchedule",
	mixins: [databaseManager, notifier],
	props: {
		active: { required: true, type: Boolean },
		theDay: { required: true },
		theLine: { required: true },
	},
	components: {
            vSelect,
        },
	data() {
		return {
            listManagers: [],
            listCheckManagers: [],
            selectedManagers: [],
            selectedResponsibleManager: [],
            // managerResponsible: [],
            newM: [],
		}
	},
	watch: {
		popupActive(value) {
			if(value) {
                this.getResponsibleDutyScheduleList();
                return;
            } 
		}
	},
	computed: {
		popupActive: {
			get() {
				return this.active;
			},
			set(newValue) {
				this.$emit("update:active", newValue);
			}
		},
	},
	methods: {
		onChangeResponsibleManager() {
			this.buildListCheckManagers();
		},
		async updateManagerResponsibleWeek() {	//new
			this.popupActive = false;
			this.$emit("confirm", this.selectedResponsibleManager.id, this.selectedManagers);
            this.selectedManagers = [];
		},
		buildListCheckManagers() {
			let newArr = this.listManagers.filter((elem) => elem.id !== 0);
			this.listCheckManagers = newArr.filter((elem) => elem.id !== this.selectedResponsibleManager.id);

			// this.listManagers.forEach(function(elem) {
			// 	if(elem.checked !== 0) {
			// 		this.selectedManagers.push(elem.id);
			// 	}
			// });

			// console.log(this.selectedManagers);

			this.selectedManagers = this.listManagers.filter((elem) => elem.checked !== 0);
		},
		async getResponsibleDutyScheduleList() {	//new
            let rez = await this.dbGetResponsibleDutyScheduleList(this.theDay, this.theLine);
            this.listManagers = rez['list_responsible_managers'];
            let findManagerResponsible = rez['responsible'];

			if(findManagerResponsible !== null && findManagerResponsible.id !== undefined) {
				let manID = findManagerResponsible;
				let manFind = null;

				this.listManagers.forEach(function(elem) {
					if(elem.id == manID.id) {
						manFind = elem;
						return;
					}
				});
				this.selectedResponsibleManager = manFind;
			} else {
				this.selectedResponsibleManager = this.$t('noManager');
			}

			this.buildListCheckManagers();
		},
	},
    created() {
        this.selectedManagers = [];
    },
};
</script>

<style lang="scss">
.frsSelectSpanManager {
	display: flex;
	line-height: 40px;
	font-size: small;
	color: black;
  
	img {
		width: 40px;
		margin-right: 10px;
	}	

}
.add-order-task {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
	.frsSelect {
		min-width: 300px;
		font-size: small;
		line-height: 20px;
		margin: auto;
	}
	.frsSelectSpanManager {
		display: flex;
		line-height: 20px;
		font-size: small;
		color: black;
	
		img {
			width: 30px;
			height: 30px;
			margin-right: 10px;
		}	

	}
	.frsSelectSpanColorManager {
		display: flex;
		line-height: 20px;
		font-size: small;
	}

	// .frsSelectSpanColorManager .feather-icon {
	// 	line-height: 20px;
	// }

	.frsColorGreenSpan {
		color: green;
	}
	.frsColorOrangeSpan {
		color: orange;
	}
	.frsColorRedSpan {
		color: red;
	}
}
</style>
